import { useIntl } from '@capsicum/common';
import { Goat, Text } from '@capsicum/common-web';
import styled from 'styled-components';

export const EmptyResults = () => {
	const { $t } = useIntl();

	return (
		<S.Wrapper>
			<Goat childBeforeImage image="ankward" testID="selectFavouriteTeam-no-results-goat" withoutTitleContainer>
				<S.ContentContainer>
					<S.EmptyResultsText variant="textTopBar">
						{$t('selectFavouriteTeam.no-results.title')}
					</S.EmptyResultsText>
					<S.EmptyResultsText variant="text3">
						{$t('selectFavouriteTeam.no-results.description')}
					</S.EmptyResultsText>
				</S.ContentContainer>
			</Goat>
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;
	export const ContentContainer = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xsmall};
	`;

	export const EmptyResultsText = styled(Text)`
		text-align: center;
	`;
}
